// routing-guard.service.ts
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import * as bootActions from 'sp-mark/feature-modules/boot/redux/boot.actions'; // <-- aggiorna il path se diverso
import { Observable, of } from 'rxjs';
import { tap, mapTo } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class InsolventMerchantGuardService implements CanActivateChild, CanActivate {

  constructor(
    private store: Store
  ) { }

  private shouldSkip(route: ActivatedRouteSnapshot): boolean {
    for (let r: ActivatedRouteSnapshot | null = route; r; r = r.parent) {
      if (r.data?.['skipCheckMerchant']) return true;
      if (r.routeConfig?.path === 'boot') return true;
    }
    return false;
  }

  private fire(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): void {
    if (!this.shouldSkip(route)) {
      this.store.dispatch(bootActions.checkSteps({flagCheckInsolventMerchant: true}));
    }
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return of(true).pipe(tap(() => this.fire(route, state)), mapTo(true));
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return of(true).pipe(tap(() => this.fire(route, state)), mapTo(true));
  }
}
